import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[interfaceAutofocus]',
  standalone: false,
})
export class AutofocusDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);

  ngAfterViewInit() {
    this.elementRef.nativeElement.focus();
  }
}
